import consumer from "./consumer";
//
consumer.subscriptions.create("AppearanceChannel", {
    // Called once when the subscription is created.
    initialized() {

    },

    // Called when the subscription is ready for use on the server.
    connected() {

        setTimeout(function () {
            this.perform("online");
        }.bind(this), 3000);
    },

    // Called when the WebSocket connection is closed.
    disconnected() {
        this.perform("offline");
    },

    // Called when the subscription is rejected by the server.
    rejected() {
        this.offline();
    }

})